import { sentenceCase } from 'change-case';
import type { FormatMessage } from '~/intl';

/**
 * @description Returns the label for an operation type, or its sentence case when it has no label yet.
 */
export const formatOperationTypeLabel = (formatMessage: FormatMessage, operationType: string) =>
  formatMessage({ id: `asyncEventType.${operationType}`, defaultMessage: sentenceCase(operationType) });
